module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image4-505ecdea7349d1270ea32fccd012b454.jpg";